module.exports = __webpack_public_path__ + "images/61ec5a92bce9121e998d76a5dd44eadc-illu_smokeSensor.svg";